import { AssessmentDetail } from '../core-data-model/AssessmentDetails.model';
import { EmailDetails } from '../core-data-model/EmailDetails.model';
// TODO should actually be something like email = { AssessmentType.Cognitive: new EmailDetails();}
// TODO - should this be exported? It's type is used elsewhere, but it should only be
//        instantiated throught the factory below - how to enforce?

export class ScheduledAssessmentDetails {
    assessments: AssessmentDetail[];
    cognitiveEmail: EmailDetails;
    behavioralEmail: EmailDetails;
    expirationDateTime: Date;
    behavioralScoreId: string;
    assessmentDateForScoreId: string;
    sendBehavioral = true;
    sendCognitive = false;
    sendCognitiveAfterBehavioralIsComplete = false;
    resendBehavioralAssessmentId: string;
}
